import { defaultLanguageForCountry, detectVisitorCountryCodeSync } from '@/lib/visitor-geo-locale';
import { parseSupportedUiLangCode, type UiLanguageCode } from '@/lib/ui-languages';

/**
 * Langue du contenu (formations, pages) pour un visiteur :
 * 1. `?lang=` explicite dans l'URL
 * 2. langue UI sélectionnée (sélecteur global LyrraOne)
 * 3. langue source du site / formation
 * 4. défaut géographique
 */
export function resolveVisitorSiteLanguage(
  sourceLanguage: string | undefined | null,
  urlLang: string | null | undefined,
  uiLanguage?: string | null,
): UiLanguageCode {
  const fromUrl = parseSupportedUiLangCode(urlLang);
  if (fromUrl) return fromUrl;

  const fromUi = parseSupportedUiLangCode(uiLanguage);
  if (fromUi) return fromUi;

  const fromSource = parseSupportedUiLangCode(sourceLanguage);
  if (fromSource) return fromSource;

  const geoLang = parseSupportedUiLangCode(
    defaultLanguageForCountry(detectVisitorCountryCodeSync()),
  );
  if (geoLang) return geoLang;

  return 'en';
}

/** Langue à propager dans les liens internes (`?lang=`) depuis l'URL courante. */
export function publicSiteLinkLang(raw: string | null | undefined): string | undefined {
  return parseSupportedUiLangCode(raw) ?? undefined;
}
